export const IFTAConstants = {
  generatedIftaReports: 'Generated IFTA Reports',
  netTaxOwed: 'Net Tax Owed',
  viewReport: 'VIEW REPORT',
};
